import { Component, Input } from '@angular/core';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { PreferencesService } from 'src/app/project/modules/preferences/preferences-service/preferences.service';
import {
  EReminderSeriesFrequency,
  TReminderSeries,
} from 'src/app/project/modules/reminders/reminders.consts';
import { transformDate } from 'src/app/project/shared/date-transformer';

@Component({
    selector: 'pp-point-reminder-modal-recurrence-display',
    templateUrl: './point-reminder-modal-recurrence-display.component.html',
    styleUrl: './point-reminder-modal-recurrence-display.component.scss',
    standalone: false
})
export class PointReminderModalRecurrenceDisplayComponent {
  @Input() ppSeries: TReminderSeries;

  formattedText = '';

  constructor(
    private translationPipe: TranslationPipe,
    private preferencesService: PreferencesService,
  ) {}

  ngOnChanges(): void {
    this.formatText();
  }

  private formatText(): void {
    const preferences = this.preferencesService.getPreferences();
    const format = preferences.dateFormat;
    if (!this.ppSeries || !this.ppSeries.frequency) {
      this.formattedText = this.translationPipe.transform('does_not_repeat');

      return;
    }

    switch (this.ppSeries.frequency) {
      case EReminderSeriesFrequency.DAILY:
        this.formattedText = this.translationPipe.transform('daily');
        break;
      case EReminderSeriesFrequency.WEEKLY:
        this.formattedText = this.translationPipe.transform('weekly');
        break;
      case EReminderSeriesFrequency.MONTHLY:
        this.formattedText = this.translationPipe.transform('monthly');
        break;
      case EReminderSeriesFrequency.YEARLY:
        this.formattedText = this.translationPipe.transform('yearly');
        break;
    }

    if (!this.ppSeries.endDateEpochMillis) {
      return;
    }

    const endDate = new Date(this.ppSeries.endDateEpochMillis);

    const formattedHour = transformDate({
      value: endDate,
      inputHourFormat: '',
      format: format,
      localTime: false,
    });

    this.formattedText += ` ${this.translationPipe.transform('until').toLowerCase()} ${formattedHour}`;
  }
}
